import React from 'react';
import ShareButton from '../ShareButton';
import { formatShortDate } from '../../utils/storage';
import './FortuneContent.css';

function FortuneContent({ fortune, type = 'zodiac' }) {
  if (!fortune) {
    return (
      <div className="fortune-content loading">
        <p>운세를 불러오는 중...</p>
      </div>
    );
  }

  return (
    <div className="fortune-content">
      <div className="fortune-header">
        <h2>{fortune.title}</h2>
        {fortune.years && (
          <p className="fortune-years">{fortune.years}</p>
        )}
        <p className="fortune-date">{formatShortDate(fortune.date)}</p>
      </div>

      <div className="fortune-section">
        <h3>✨ 총운</h3>
        <p className="fortune-text">{fortune.overall}</p>
      </div>

      {fortune.love && (
        <div className="fortune-section">
          <h3>💕 애정운</h3>
          <p className="fortune-text">{fortune.love}</p>
        </div>
      )}

      {fortune.money && (
        <div className="fortune-section">
          <h3>💰 금전운</h3>
          <p className="fortune-text">{fortune.money}</p>
        </div>
      )}

      {fortune.health && (
        <div className="fortune-section">
          <h3>🏥 건강운</h3>
          <p className="fortune-text">{fortune.health}</p>
        </div>
      )}

      {fortune.advice && (
        <div className="fortune-section">
          <h3>💡 오늘의 조언</h3>
          <p className="fortune-text">{fortune.advice}</p>
        </div>
      )}

      {fortune.avoid && (
        <div className="fortune-section warning">
          <h3>⚠️ 피해야 할 것</h3>
          <p className="fortune-text">{fortune.avoid}</p>
        </div>
      )}

      {fortune.warning && (
        <div className="fortune-section warning">
          <h3>⚠️ 주의사항</h3>
          <p className="fortune-text">{fortune.warning}</p>
        </div>
      )}

      {fortune.insight && (
        <div className="fortune-section insight">
          <h3>🔮 심층 통찰</h3>
          <p className="fortune-text">{fortune.insight}</p>
        </div>
      )}

      <div className="fortune-lucky">
        <h3>🍀 행운 정보</h3>
        <div className="lucky-grid">
          {fortune.luckyNumbers && fortune.luckyNumbers.length > 0 && (
            <div className="lucky-item">
              <span className="lucky-label">행운의 숫자</span>
              <div className="lucky-numbers">
                {fortune.luckyNumbers.map((num, idx) => (
                  <span key={idx} className="lucky-number">{num}</span>
                ))}
              </div>
            </div>
          )}

          {fortune.luckyColor && (
            <div className="lucky-item">
              <span className="lucky-label">행운의 색</span>
              <span className="lucky-value color">{fortune.luckyColor}</span>
            </div>
          )}

          {fortune.luckyDirection && (
            <div className="lucky-item">
              <span className="lucky-label">행운의 방향</span>
              <span className="lucky-value">{fortune.luckyDirection}</span>
            </div>
          )}

          {fortune.luckyItem && (
            <div className="lucky-item">
              <span className="lucky-label">행운의 아이템</span>
              <span className="lucky-value">{fortune.luckyItem}</span>
            </div>
          )}

          {fortune.luckyTime && (
            <div className="lucky-item">
              <span className="lucky-label">행운의 시간</span>
              <span className="lucky-value">{fortune.luckyTime}</span>
            </div>
          )}

          {fortune.luckyActivity && (
            <div className="lucky-item full-width">
              <span className="lucky-label">추천 활동</span>
              <span className="lucky-value">{fortune.luckyActivity}</span>
            </div>
          )}

          {fortune.luckyPlace && (
            <div className="lucky-item full-width">
              <span className="lucky-label">추천 장소</span>
              <span className="lucky-value">{fortune.luckyPlace}</span>
            </div>
          )}
        </div>
      </div>

      <ShareButton
        type={type}
        data={fortune}
      />
    </div>
  );
}

export default FortuneContent;
